// A table or a block of code wider than its column scrolls inside it, and a
// region that scrolls has to take the keyboard's focus to be scrolled by it.
// Chrome and Firefox make such a region a tab stop themselves; Safari does
// not. It is a tab stop only while it has something out of sight.
(function () {
  if (window.Faubourg && window.Faubourg.rte) return;
  (window.Faubourg = window.Faubourg || {}).rte = true;

  function mark(region) {
    var scrolls = region.scrollWidth > region.clientWidth;
    if (scrolls && !region.hasAttribute('tabindex')) {
      region.setAttribute('tabindex', '0');
      region.setAttribute('data-rte-scrolls', '');
    } else if (!scrolls && region.hasAttribute('data-rte-scrolls')) {
      region.removeAttribute('tabindex');
      region.removeAttribute('data-rte-scrolls');
    }
  }

  var watch =
    'ResizeObserver' in window
      ? new ResizeObserver(function (entries) {
          for (var index = 0; index < entries.length; index += 1) mark(entries[index].target);
        })
      : null;

  function scan(root) {
    var regions = root.querySelectorAll('.rte table, .rte pre');
    for (var index = 0; index < regions.length; index += 1) {
      if (watch) watch.observe(regions[index]);
      else mark(regions[index]);
    }
  }

  scan(document);
  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
})();
